import { useApolloClient } from "@apollo/client";
import { GET_AUCTION_FORMS } from "core/apollo/graphql";
import { Auction } from "core/types";
import { useCallback } from "react";

export function useUpdateAuctionFormsCache() {
  const client = useApolloClient();

  return useCallback(
    (auction: Auction | null) => {
      const auctionId = auction?.id;
      if (!auctionId) return;

      client.cache.updateQuery<{ auction: Auction | null }>(
        { query: GET_AUCTION_FORMS, variables: { auctionId } },
        (data) => ({
          auction: {
            ...data?.auction,
            ...auction,
            __typename: "Auction",
            forms: auction.forms ?? [],
            id: auctionId,
          },
        }),
      );
    },
    [client],
  );
}
